<template>
  <div class="jurisd">
    <el-form-item label="购买权限：" class="width100" prop="customerLevelBuyList" required :rules="{required: true,message: '请选择',trigger: 'change'}">
      <div class="lab" :class="{'active': item.isActive}" v-for="(item,index) in  form.customerLevelBuyList" :key="'buy-' + index" @click="handleActive(item)">
        <i class="el-icon-success" v-if="item.isActive"></i>{{item.value}}
      </div>
    </el-form-item>
  </div>
</template>
<script>
import customerLevelApi from '@/api/sys/customerLevel'
import sysRoleApi from '@/api/sys/sysRole'
import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'
export default {
  props: ['form', 'bisicsInfo', 'type'],  //type 1 秒杀商品 2 积分商品 3普通商品
  data() {
    return {
      options: {
        customerLevel: [],  //   业务线-客户级别
        registerRole: [],   //职能线-用户角色
        technicalServiceLevel: []  //技术线-技术线级别
      },
    }
  },
  created() {
    this.getCustomerLevel()
    this.getRegisterRole()
    this.getTechnicalServiceLevel()
  },
  methods: {
    handleAuthsInternal() {
      let { isAuthsInternal } = this.form;
      let state = isAuthsInternal ? 0 : 1
      this.$set(this.form, 'isAuthsInternal', state)
      this.$forceUpdate();
    },
    getCustomerLevel() {
      customerLevelApi.fetchList({ levelSortSign: -1 }).then(({ data }) => {
        let arr = []
        data.forEach(item => {
          arr.push({ value: item.name, key: item.id })
        })
        let findIdx = arr.findIndex(item => item.key === 8)
        if (findIdx > -1) arr.splice(findIdx, 1)
        this.options.customerLevel = arr;
        let txt = +this.type === 1 ? 'product_seckill_buy_auth' : (+this.type === 2 ? 'product_point_buy_auth' : 'product_buy_auth')
        let txt1 = +this.type === 1 ? 'product_seckill_price_auth' : (+this.type === 2 ? 'product_point_price_auth' : 'product_price_auth')
        this.$set(this.form, 'customerLevelBuyList', this.clacFuc(txt, 1))
        this.$set(this.form, 'customerLevelList', this.clacFuc(txt1, 4))
      })
    },
    getTechnicalServiceLevel() {
      technicalServiceLevelApi.findOptions().then(({ data }) => {
        this.options.technicalServiceLevel = data
        let txt1 = +this.type === 1 ? 'product_seckill_price_auth' : (+this.type === 2 ? 'product_point_price_auth' : 'product_price_auth')
        this.$set(this.form, 'technicalServiceLevelList', this.clacFuc(txt1, 2))
      })
    },
    getRegisterRole() {
      sysRoleApi.fetchList({ pageNo: 1, pageSize: 1000, roleType: 2 }).then(({ data }) => {
        let arr = []
        data.list.forEach(item => {
          arr.push({ value: item.roleName, key: item.id })
        })
        let findIdx = arr.findIndex(item => item.key === 1)
        if (findIdx > -1) arr.splice(findIdx, 1)
        this.options.registerRole = arr
        let txt1 = +this.type === 1 ? 'product_seckill_price_auth' : (+this.type === 2 ? 'product_point_price_auth' : 'product_price_auth')
        this.$set(this.form, 'sysRoleList', this.clacFuc(txt1, 3))
      })
    },
    clacFuc(code, type) {
      let { customerLevel, technicalServiceLevel, registerRole } = this.options
      let option = (type === 1 || type === 4) ? customerLevel : (type === 2 ? technicalServiceLevel : registerRole)
      let arr = JSON.parse(JSON.stringify(option))
      if (!option.length) return arr
      //处理 秒杀商品和积分商品购买权限只有体验班、研修班
      if (type === 1 && (+this.type === 1 || +this.type === 2)) {
        const neededIds = [6, 7];
        arr = arr.filter(obj => neededIds.includes(obj.key));
      }
      //处理 系统商品
      if (type === 1 && +this.type === 3) {
        const neededIds = [3, 4, 5, 6, 7];
        arr = arr.filter(obj => neededIds.includes(obj.key));
      }
      arr.forEach(item => {
        if (this.form.id) {
          let key = type === 1 ? 'customerLevelBuyList' : (type === 4 ? 'customerLevelList' : (type === 2 ? 'technicalServiceLevelList' : 'sysRoleList'))
          let find = this.form[key].find(it => it === item.key)
          item.isActive = find ? true : false
        } else {
          let key = (type === 1 || type === 4) ? 'customerLevel' : (type === 2 ? 'technicalServiceLevel' : 'registerRole')
          let row = this.bisicsInfo.find(item => item.code === code)
          if (row.isEnable) {
            let find = row.content2[key].find(it => it === item.key)
            item.isActive = find && row.isEnable ? true : false
          } else {
            item.isActive = false
          }
        }
      });
      return arr
    },
    handleActive(item) {
      item.isActive = !item.isActive
      this.$forceUpdate();
    },
  }
}
</script>
<style lang="scss" scoped>
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
.jurisd {
  .lab {
    font-size: 14px;
    color: #8f8e8e;
    border-radius: 4px;
    padding: 0 18px;
    display: inline-block;
    border: 1px solid #c5c5c5;
    margin: 5px;
    position: relative;
    cursor: pointer;
    &.active {
      background: #5dbde7;
      color: #fff;
      border-color: #5dbde7;
    }
    i {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}
</style>